import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DialogResult, DialogResultType } from "../../DialogResult";
import {InteractPoDPage, ReportSource} from '../../../api/models';
import { ReportExportService } from "../../../api/services";
import {PoDData} from '../edit-interactive-dialog/edit-interactive-dialog.component';

export interface EditReportSourceDialogData {
  dialogTitle: string;
  reportSource: ReportSource;
  podPages: InteractPoDPage[];
}

@Component({
  selector: "edit-report-source-dialog",
  styleUrls: ["edit-report-source-dialog.component.css"],
  templateUrl: "./edit-report-source-dialog.component.html",
})
export class EditReportSourceDialogComponent {
  public Result: DialogResult;
  public fileToUpload: File = null;
  public uploadingReportSource: boolean = false;

  public podData: PoDData[] = [];
  public newPageDisplayName: string = "";
  public newPagePage: string = "";

  constructor(
    public dialogRef: MatDialogRef<EditReportSourceDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EditReportSourceDialogData,
    private reportExportService: ReportExportService
  ) {
    this.Result = new DialogResult();
    this.Result.ResultType = DialogResultType.Cancel;
    this.Result.ResultData = null;

    data.podPages.forEach(podPage => {
      this.podData.push({
        displayName: podPage.displayName,
        page: podPage.page,
        order: podPage.order
      });
    });
  }

  handleFileInput(files: FileList) {
    this.fileToUpload = files.item(0);
  }

  onCancelClick(): void {
    this.dialogRef.close(this.Result);
  }

  onConfirmClick(): void {

    this.uploadingReportSource = true;

    const callParams: ReportExportService.ReportExportCreateReportSourceParams = {
      upload: this.fileToUpload,
      reportSourceReportSourceId: this.data.reportSource.reportSourceId,
      reportSourceName: this.data.reportSource.name,
      reportSourceFileName: this.data.reportSource.fileName,
      reportSourceFileId: this.data.reportSource.fileId,
      reportSourceDescription: this.data.reportSource.description,
      PreFilterCompanyAvailable: this.data.reportSource.preFilterCompanyAvailable,
      PreFilterIndustryAvailable: this.data.reportSource.preFilterIndustryAvailable,
      PreFilterOccupationAvailable: this.data.reportSource.preFilterOccupationAvailable,
      PreFilterRegionAvailable: this.data.reportSource.preFilterRegionAvailable,
      PreFilterTitleAvailable: this.data.reportSource.preFilterTitleAvailable,
      Active: this.data.reportSource.active
    };

    if (this.data.reportSource.reportSourceId == -1) {
      this.reportExportService
        .reportExportCreateReportSource(callParams)
        .subscribe((result) => {

          this.reportExportService.reportExportUpdateReportSourcePrintOnDemandPages({
            reportSourceId: this.data.reportSource.reportSourceId,
            pages: this.podData.map(function (podPage) {
                const podPageData: InteractPoDPage = {
                  interactPoDPageId: 0,
                  reportSourceId: result.reportSourceId,
                  displayName: podPage.displayName,
                  page: podPage.page,
                  order: podPage.order
                };
                return podPageData;
              }
            )
          }).subscribe((pagesResult) => {
            this.Result.ResultType = DialogResultType.Ok;
            this.Result.ResultData = null;
            this.dialogRef.close(this.Result);
          });
        }, (error) => {
          alert(error.error);
        }
      );
    } else {
      this.reportExportService
        .reportExportUpdateReportSource(callParams)
        .subscribe((result) => {

            this.reportExportService.reportExportUpdateReportSourcePrintOnDemandPages({
              reportSourceId: this.data.reportSource.reportSourceId,
              pages: this.podData.map(function (podPage) {
                  const podPageData: InteractPoDPage = {
                    interactPoDPageId: 0,
                    reportSourceId: result.reportSourceId,
                    displayName: podPage.displayName,
                    page: podPage.page,
                    order: podPage.order
                  };
                  return podPageData;
                }
              )
            }).subscribe((pagesResult) => {
              this.Result.ResultType = DialogResultType.Ok;
              this.Result.ResultData = null;
              this.dialogRef.close(this.Result);
            });
        },
          (error) => {
            alert(error.error);
          });
    }
  }

  movePageUp(page: PoDData) {
    var index = this.podData.indexOf(page);
    if (index > 0) {
      var temp = this.podData[index];
      this.podData[index] = this.podData[index - 1];
      this.podData[index - 1] = temp;

      this.podData[index].order = index;
      this.podData[index - 1].order = index - 1;
    }

    return false;
  }

  movePageDown(page: PoDData) {
    var index = this.podData.indexOf(page);
    if (index < this.podData.length - 1) {
      var temp = this.podData[index];
      this.podData[index] = this.podData[index + 1];
      this.podData[index + 1] = temp;

      this.podData[index].order = index;
      this.podData[index + 1].order = index + 1;
    }

    return false;
  }

  removePage(page: PoDData) {
    this.podData.splice(this.podData.indexOf(page), 1);
    this.podData.forEach((podPage, index) => {
      podPage.order = index;
    });

    return false;
  }

  addPage() {
    this.podData.push({
      displayName: this.newPageDisplayName,
      page: this.newPagePage,
      order: this.podData.length
    });

    this.newPageDisplayName = '';
    this.newPagePage = '';

    return false;
  }
}
